// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"96ccadd8","128":"828cdb21","153":"ee19e0de","345":"5feb6ba3","609":"748e05e4","647":"587bdaa5","764":"301c9b08","942":"747b0610"}[chunkId] + ".chunk.js";
};